var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "login", on: { click: _vm.vkLogion } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }